export default __webpack_public_path__ + "static/bi-d439520b6c880816362657385df095d6.svg";